import { useEffect, useMemo, useState } from "react";

import './../Update.css';

import Axios from 'axios';

import Env from "../../../services/Env";

import Comp_PageName from "../../../components/PageName";

import { GetDataPage, RegisterDataPage, UnRegisterDataPage } from "../../../interface/Data";

import { OpenPage } from "../../../services/OpenPage";
import { CallbackError, CallbackSuccess, CheckPassword } from "../../../services/Function";

import { Btn } from "../../../components/Input";

interface DataUpdate {
    id             : number;
    id_client      : number;
    type           : number;
    version_       : number;
    date           : string;
    comporate_name : string;
    file           : string;
    text           : string;
    status_data    : boolean;
}

export default function Page_Update_Details() {

    const [ listData, setListData ] = useState<{ [key: string]: DataUpdate }>(GetDataPage("updates") || {});

    const [ closing, setClosing ] = useState<boolean>(false);

    // Clicar no fundo escurecido (fora do painel) fecha igual ao botao Cancel.
    function handleBackdrop(event: React.MouseEvent<HTMLFormElement>){
        if(event.target === event.currentTarget){
            handleClose();
        }
    }

    function handleClose() {
        setClosing(true);
        setTimeout(() => {
            OpenPage('updates');
        }, 300);
    }

    async function SaveData(event: React.FormEvent<HTMLFormElement>) {
        event.preventDefault();        
        try {
            const formData = new FormData();
            formData.append('type_page', 'updates');
            formData.append('type_data', 'edit_or_register');

            const response = await Axios.post<DataUpdate>(Env.apiUrl, formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });            
            
            if(response.data.status_data){
                
                CallbackSuccess("Saved information", "The update details have been successfully saved.");

                // Gravou: fecha o painel e volta para a listagem. O PopUp de sucesso
                // e global, entao continua na tela depois do Details sair.
                handleClose();

            }else {
                CallbackError("Error saving information", "There was an issue saving the update details. Please try again.");
            }
            
        }catch (error){
            CallbackError("Error saving information", "There was an issue saving the update details. Please try again.");
        }
    }

    useEffect(() => {
        function handleData(data: any) {
            setListData(data || {});
        }
        RegisterDataPage('updates', handleData);
        return () => UnRegisterDataPage('updates', handleData);
    }, []);

    return(
        <form className="page_details Page_Update_Details" onSubmit={ SaveData } onClick={ handleBackdrop }>
            <div className={ `content_details ${ closing ? 'content_details_close' : '' }` }>
                
                <Comp_PageName
                    title="Update version site"
                    subtitle="Fill in the details to update the site version"
                />

                <div className="div_btn div_row">
                    <Btn title="Cancel" type="btn_cancel" OpenFuncition={ handleClose } />
                    <Btn title="Save" />
                </div>
            </div>
        </form>
    )
}